<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-action>
          <hb-icon>language</hb-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 font-weight-bold">{{ selectedLanguage.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list>
      <v-list-item
          v-for="item in languageItems"
          :key="item.value"
          :input-value="selectedLanguage.value === item.value"
          @click="languageChanged(item)"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import api from '../apicollection';

export default {
  data() {
    return {
      languageItems: [
        {text: 'English', value: 'en'},
        {text: 'Suomi', value: 'fi'},
        {text: 'Svenska', value: 'sv'},
      ],
      selectedLanguage: {text: 'English', value: 'en'},
    };
  },
  methods: {
    async languageChanged(language) {
      try {
        const user = await api.updateUserSelf(this.$user.id, {
          language: language.value,
          pushNotificationsEnabled: this.$user.pushNotificationsEnabled,
        });
        this.$setUser(user);
        this.$i18n.locale = user.language;
        this.$vuetify.lang.current = user.language;
        this.selectedLanguage = language;
        window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    const userLanguageIndex = this.languageItems.findIndex(l => l.value === this.$user.language);
    if (userLanguageIndex > -1) {
      this.selectedLanguage = this.languageItems[userLanguageIndex];
    }
  },
};
</script>

<style scoped></style>
